export default __webpack_public_path__ + "static/media/logout_ico.772cac12.svg";